import everything from './everything';
import home from './home';
import project from './project';
import projects from './projects';
import settings from './settings';
import planning from './planning';
import reports from './reports';
import people from './people';
import welcome from './welcome';
import getLastUpdatedProjectId from '../../utils/helpers/getLastUpdatedProjectId';

export default [
  {
    path: '/idle',
    component: () => import('@sections/Idle'),
  },
  {
    path: '/json-to-project',
    component: 'json-to-project',
    props: {
      name: 'json-to-project',
    },
  },
  {
    path: '/playground',
    component: 'playground',
    props: {
      name: 'playground',
    },
  },
  {
    path: '/budgets', // TODO: check if this is all good
    component: () => import('@pages/Budgets'),
  },
  {
    path: '/getting-started',
    component: 'sample-projects-container',
    props: {
      name: 'sample-projects-container',
    },
  },
  {
    path: '/onboarding/step/:step?',
    component: 'onboarding-project-container',
    props: (route) => ({
      name: 'onboarding-project-container',
      step: parseInt(route.params.step, 10),
      projectName: route.params.projectName,
    }),
  },
  {
    path: '/embed',
    component: 'tko-component',
    props: {
      name: 'page-embed',
    },
  },
  {
    path: '/time*',
    redirect: '/everything/time',
  },
  ...welcome,
  {
    path: '(.*)',
    component: 'app-layout',
    children: [
      ...everything,
      ...home,
      ...people,
      ...projects,
      ...settings,
      {
        path: '/projects',
        meta: {
          pageName: 'Projects',
        },
      },
      planning,
      reports,
      {
        path: '/calendar',
        meta: {
          pageName: 'Calendar',
          menuPermission: 'canAccessCalendar',
        },
      },
      {
        path: '/legacytogrow',
        component: 'growvember',
        meta: {
          inOwnerCompany: true,
          isAccount: true,
          menuPermission: 'administrator',
          pageName: 'Grow',
        },
      },
      ...project,
      {
        path: '/search/:searchTerm',
        // Going to the search page means the quick search is cleared
        beforeEnter: ({ dispatch }, to, from, next) => {
          dispatch('quickSearch/clear');
          next();
        },
      },
      {
        path: '/cancel',
        component: 'cancellation',
        props: {
          name: 'cancellation',
          mode: 'cancel',
        },
        meta: {},
      },
      {
        path: '/downgrade',
        component: 'cancellation',
        props: {
          name: 'cancellation',
          mode: 'downgrade',
        },
        meta: {},
      },
      {
        path: '/trialstarted/:feature',
        component: 'trialstarted',
        props: (route) => ({
          pageName: 'Trial Started',
          feature: route.params.feature,
          enableTrial: !!route.query.enableTrial,
        }),
        meta: {},
      },
      {
        path: '/migrate/',
        component: 'migrate',
        props: {
          name: 'migrate',
        },
        meta: {
          disableGating: true,
        },
      },
      {
        path: '/launchmodal/:modal',
        beforeEnter({ dispatch, state }, to, from, next) {
          if (to.params.modal === 'junediscount') {
            dispatch('modals/tko/open', {
              id: 'enterpriseForm',
              args: {
                isSalesContact: true,
              },
            });
          } else if (to.params.modal === 'profilePhoto') {
            dispatch('modals/tko/open', {
              id: 'addOrEditPerson',
              args: {
                personId: state.user.id,
                uploadPhoto: true,
              },
            });
          }
          next(from);
        },
      },
      {
        path: '/lastproject/:projectroute*',
        async beforeEnter(_, to, from, next) {
          const projectId = await getLastUpdatedProjectId();
          if (projectId) {
            next(`/projects/${projectId}/${to.params.projectroute}`);
          } else {
            next('/projects/list');
          }
        },
      },
      {
        path: '/(email|checkout)gateway/plans',
        component: 'emailgateway',
        props: (route) => ({
          entryPointName: route.query.entryPointName,
        }),
        meta: {
          hasHeader: false,
        },
      },
      {
        path: '/(email|checkout)gateway/:planId/:discount/:campaign',
        component: 'emailgateway',
        props: (route) => ({
          campaign: route.params.campaign,
          planId: Number(route.params.planId),
          discount: route.params.discount,
          entryPointName: route.query.entryPointName,
        }),
        meta: {
          hasHeader: false,
        },
      },
      {
        path: '/sdr/call',
        component: 'sdrcall',
        props: {
          name: 'Call',
        },
        meta: {
          hasHeader: false,
        },
      },
      {
        path: '/contact/:type',
        component: 'sdrcall',
        props: (route) => ({
          type: route.params.type,
        }),
        meta: {
          hasHeader: false,
        },
      },
      {
        path: '*',
      },
    ],
  },
];
